import type { UserProfilePreviewDto } from '@tracedocuments/types';

import { apiFetch } from './fetch';

export async function fetchUserProfilePreview(userId: string): Promise<UserProfilePreviewDto> {
  const res = await apiFetch(`/api/users/${encodeURIComponent(userId)}/profile-preview`);
  if (!res.ok) throw new Error('profile preview failed');
  return res.json();
}
